import React from 'react';

const ContainerForm: React.FC = ({ children }) => {
  return <div>{children}</div>;
};

export default ContainerForm;
